<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>All Rubrics Subject Consolidated Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @change="putallnull()"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
                        getDiv();
                       putnull();
                        "
                        persistent-hint
                        hint="Please select standard"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="div"
                        item-value="div_off_id"
                        :items="div_list"
                        item-text="div_name"
                        label="Division"
                        outlined
                        persistent-hint
                        hint="Please select division"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="entrytype"
                        item-value="id"
                        :items="entrytype_list"
                        item-text="name"
                        label="Select Course Tpe"
                        outlined
                        persistent-hint
                        hint="Please select Course Tpe"
                    />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="status"
                        :items="status_list"
                        item-text="name"
                        item-value="id"
                        label="Status"
                        outlined
                        persistent-hint
                        hint="Select Status"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && entrytype">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <span v-if="result!=''">
                <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
                <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                    <v-icon left color="success">mdi-export</v-icon>
                    Export
                </v-btn>
                </v-col>
         <!-- <v-simple-table fixed-header height="500px" dense class="elevation-1" v-if="result!=''">
            
                <tr>
                       <th colspan="4"></th>
                        <th class=""  v-for="header,index in crs_list" :key="index" :colspan="crs_list_ass_details_size[index]">
                            <center>{{ header }}</center>
                        </th>
                    </tr>
                     <tr>
                       <th colspan="4"></th>
                        <th class=""  v-for="header,index1 in crs_list_ass_details" :key="index1" :colspan="crs_list_rubrics_details_size[index1]">
                            <center>{{ header }}</center>
                        </th>
                    </tr>
                     <tr>
                       <th>Sr.No.</th>
                       <th>Roll No.</th>
                       <th class="text-left">Name</th>
                       <th>Division</th>
                        <th class=""  v-for="header,index1 in crs_list_rubrics_details" :key="index1">
                            <center>{{ header }}</center>
                        </th>
                    </tr>
                    <tbody style="overflow-y: scroll;">
                     <tr v-for="(s, index) in result" :key="index">
                       <td>{{ index+1 }}</td>
                       <td>{{ s.rollNo }}</td>
                       <td class="text-left">{{ s.name }}</td>
                       <td>{{ s.division }}</td>
                        <td v-for="(m, index1) in s.marks" :key="index1">
                            {{ m }}
                        </td>
                    </tr>
                    </tbody>
         </v-simple-table> -->
            <v-simple-table fixed-header height="500px" dense class="elevation-1 my-custom-table" v-if="result!=''">
                <template v-slot:default>
                    <thead>
                        <!-- Row 1 -->
                        <tr class="header-row-1">
                            <th colspan="4" class="sticky-th freeze corner-blank"></th>
                            <th class="sticky-th text-center" v-for="(header, index) in crs_list" :key="'crs'+index" :colspan="crs_list_ass_details_size[index]">
                                {{ header }}
                            </th>
                        </tr>
                        
                        <!-- Row 2 -->
                        <tr class="header-row-2">
                            <th colspan="4" class="sticky-th freeze corner-blank"></th>
                            <th class="sticky-th text-center" v-for="(header, index1) in crs_list_ass_details" :key="'ass'+index1" :colspan="crs_list_rubrics_details_size[index1]">
                                {{ header }}
                            </th>
                        </tr>
                        
                        <!-- Row 3 -->
                        <tr class="header-row-3">
                            <th class="sticky-th text-center freeze c1">Sr.No.</th>
                            <th class="sticky-th text-center freeze c2">Roll No.</th>
                            <th class="sticky-th text-left freeze c3">Name</th>
                            <th class="sticky-th text-center freeze c4">Division</th>
                            <th class="sticky-th text-center" v-for="(header, index1) in crs_list_rubrics_details" :key="'rub'+index1">
                                {{ header }}
                            </th>
                        </tr>
                    </thead>
                    
                    <tbody>
                        <tr v-for="(s, index) in result" :key="index">
                            <td class="freeze c1">{{ index+1 }}</td>
                            <td class="freeze c2">{{ s.rollNo }}</td>
                            <td class="text-left freeze c3">{{ s.name }}</td>
                            <td class="freeze c4">{{ s.division }}</td>
                            <td v-for="(m, index1) in s.marks" :key="'mark'+index1">
                                {{ m }}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        
        </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import * as XLSX from "xlsx";
    export default {
        data() {
            return {
                loader: false,
                overlay: false,
                selected: [],
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                standard: null,
                division: null,
                course: null,
                academicyear: null,
                org_basic_data: [],
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: "0",
                entrytype_list: [],
                entrytype: null,
                crs_list_ass_details:[],
                crs_list_ass_details_size:[],
                crs_list_rubrics_details:[],
                crs_list_rubrics_details_size:[],
                result:[],
                crs_list:[]
            };
        },

        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            putallnull() {
                this.div_list = null;
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            getreport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                    entrttype: this.entrytype,
                    status: this.status,
                };
                this.fetch_loader = true;
                axios
                    .post("/Examination/getAllSubjectRubricsReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list_ass_details = res.data.crs_list_ass_details
                            this.crs_list_ass_details_size = res.data.crs_list_ass_details_size
                            this.crs_list_rubrics_details = res.data.crs_list_rubrics_details
                            this.crs_list_rubrics_details_size = res.data.crs_list_rubrics_details_size
                            this.result = res.data.result
                            this.crs_list = res.data.crs_list
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.show = true;
                        this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div_by_access")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                        this.entrytype_list = ["All"];
                        this.entrytype_list = res.data.entrytype_list;
                        this.entrytype_list.unshift("All");
                        this.entrytype = this.entrytype_list[0];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            CartPdf() {
                var tab = document.getElementById("tab");
                var tab1 = document.getElementById("tab1");
                var win = window.open("", "", "height=700,width=1000");
                win.document.write(tab.outerHTML, tab1.outerHTML);
                win.document.close();
                win.print();
            },
            downloadFile() {
                this.loader = true;
                let sheetData = [];
                let headerRow1 = ["S.No", "Roll No", "Name", "Division"];
                this.crs_list.forEach((subject, i) => {
                    let count = this.crs_list_ass_details_size[i] || 0;

                    for (let j = 0; j < count; j++) {
                        headerRow1.push(j === 0 ? subject : "");
                    }
                });

                let headerRow2 = ["", "", "", ""];

                this.crs_list_ass_details.forEach((ass, i) => {
                    let count = this.crs_list_rubrics_details_size[i] || 0;

                    for (let j = 0; j < count; j++) {
                        headerRow2.push(j === 0 ? (ass || " ") : "");
                    }
                });

                let headerRow3 = ["", "", "", ""];

                this.crs_list_rubrics_details.forEach((r) => {
                    headerRow3.push(r || " ");
                });

                sheetData.push(headerRow1);
                sheetData.push(headerRow2);
                sheetData.push(headerRow3);

                this.result.forEach((item, index) => {
                    let row = [
                        index + 1,
                        item.rollNo || "",
                        item.name || "",
                        item.division || ""
                    ];

                    let subjectIndex = 0;
                    let runningTotal = 0;

                    item.marks.forEach((mark, i) => {
                        if (i >= runningTotal + (this.crs_list_ass_details_size[subjectIndex] || 0)) {
                            runningTotal += this.crs_list_ass_details_size[subjectIndex];
                            subjectIndex++;
                        }
                        row.push(mark || "NA");
                    });

                    sheetData.push(row);
                });

                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                let merges = [];
                let colIndex = 4;
                this.crs_list.forEach((subject, i) => {
                    let count = this.crs_list_ass_details_size[i] || 0;

                    if (count > 0) {
                        merges.push({
                            s: { r: 0, c: colIndex },
                            e: { r: 0, c: colIndex + count - 1 }
                        });
                    }

                    colIndex += count;
                });

                colIndex = 4;
                this.crs_list_ass_details.forEach((ass, i) => {
                    let count = this.crs_list_rubrics_details_size[i] || 0;

                    if (count > 0) {
                        merges.push({
                            s: { r: 1, c: colIndex },
                            e: { r: 1, c: colIndex + count - 1 }
                        });
                    }

                    colIndex += count;
                });

                for (let i = 0; i < 4; i++) {
                    merges.push({
                        s: { r: 0, c: i },
                        e: { r: 2, c: i }
                    });
                }

                ws["!merges"] = merges;
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Rubrics Report");
                XLSX.writeFile(wb, "AllRubricsSubjectReport.xlsx");
                this.loader = false;
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .table {
        border: none !important;
    }
    .scroll {
        overflow-x: scroll;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(
            to right,
            #2c5364,
            #203a43,
            #0f2027
        ) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(
            to right,
            #2c5364,
            #203a43,
            #0f2027
        ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    .my-custom-table table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
    }

    .my-custom-table thead .header-row-1 th.sticky-th {
        height: 36px !important; 
        top: 0 !important;
        z-index: 3 !important;
        color: black !important;
        background-color: white !important; 
    }

    .my-custom-table thead .header-row-2 th.sticky-th {
        height: 36px !important;
        top: 36px !important;
        z-index: 3 !important;
        color: black !important;
        background-color: white !important; 
    }

    .my-custom-table thead .header-row-3 th.sticky-th {
        height: 36px !important;
        top: 72px !important; 
        z-index: 3 !important;
        color: black !important;
        background-color: white !important; 
    }

    .my-custom-table th.sticky-th {
        position: sticky !important;
        border-bottom: 1px solid #ccc;
        background-color: white !important; 
    }

    .my-custom-table table {
        table-layout: fixed !important;
        width: max-content !important;
    }

    .my-custom-table th,
    .my-custom-table td {
        box-sizing: border-box !important;
    }

    .my-custom-table .freeze {
        position: sticky !important;
        background-color: #fff !important;
    }

    .my-custom-table .c1 { left: 0px;   width: 80px;  min-width: 80px;  max-width: 80px; }
    .my-custom-table .c2 { left: 80px;  width: 90px;  min-width: 90px;  max-width: 90px; }
    .my-custom-table .c3 { left: 170px; width: 160px; min-width: 160px; max-width: 160px; }
    .my-custom-table .c4 { left: 330px; width: 90px;  min-width: 90px;  max-width: 90px; box-shadow: inset -1px 0 0 #ccc; }

    .my-custom-table .corner-blank {
        left: 0px;
        width: 400px !important;
        min-width: 400px !important;
        max-width: 400px !important;
    }

    .my-custom-table thead th.sticky-th.freeze {
        z-index: 10 !important;
    }

    .my-custom-table tbody td.freeze {
        z-index: 2;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: small !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
</style>
